import { render, staticRenderFns } from "./TranslateDialogue.vue?vue&type=template&id=b4d8dd18&scoped=true"
import script from "./TranslateDialogue.vue?vue&type=script&lang=js"
export * from "./TranslateDialogue.vue?vue&type=script&lang=js"
import style0 from "./TranslateDialogue.vue?vue&type=style&index=0&id=b4d8dd18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d8dd18",
  null
  
)

export default component.exports